<template>
  <div
  v-show="isGetVerificationSuccess && verificationIsCompleted !== null"
  class="verification-page">

    <div class="noti-bar" ref="noti-bar"
    v-bind:class="{
      'noti-bar-visible': !verificationIsCompleted && !verificationResult
    }">
      <div>
        <span>Waiting for your response... {{remainVerificationTime}}s</span>
      </div>
    </div>

    <!-- <div class="header">Touch video to view live video</div> -->

    <div class="snapshot-list">

      <!-- <div class="tab-btns">
        <div
        v-on:click="onClickEventVideo" ontouchstart="" :class="{'sel-tab': curTab === 'event'}"
        class="tab-btn">Event video</div>
        <div
        v-on:click="onClickLiveVideo" ontouchstart="" :class="{'sel-tab': curTab === 'live'}"
        class="tab-btn">Live video</div>
      </div>
      -->

      <div class="snapshot-containers-wrapper scrollable -x scrollbar-hidden" v-on:scroll="snapshotViewScroll" ref="snapshot-container">

        <div
        ref="event-snapshot"
        class="snapshot-container">
          <CompVerificationEventMedia v-on:onEventErr="eventErr"/>
        </div>

        <div
        ref="live-snapshot"
        class="snapshot-container">
          <comp-verification-live-snapshot></comp-verification-live-snapshot>
        </div>

      </div>

    </div>

    <div class="info-menu">
      <div class="row between mb-5 align-center">
        <div>
          <div class="time-label" v-if="curTab==='event'">
            <span class='event-time'>{{verificationLocaleString}} </span><span class="friendly-time">{{friendlyVerificationTimeString}}</span></div>
          <div class="time-label row" v-if="curTab==='live'">
            <div class="dot-holder">
              <div class="dot"></div>
              <div class="pulse"></div>
            </div>
            <span class="live-txt">Live</span>
          </div>
        </div>
        
        <div class="tab-btns">
          <div
          v-on:click="onClickEventVideo" ontouchstart="" :class="{'sel-tab': curTab === 'event'}"
          class="tab-btn"><div>Event</div></div>
          <div
          v-on:click="onClickLiveVideo" ontouchstart="" :class="{'sel-tab': curTab === 'live'}"
          class="tab-btn"><div>Live</div></div>
        </div>
      </div>
      <div class="row">
        <div class="device-name">{{tokenInfo.deviceName}}</div>
        <div class="row">
          <div class="zone-number" v-for="(alarmZone, idx) in tokenInfo.alarmZones" v-bind:key="idx">
            <div class="zone-number-txt">Zone#: {{alarmZone}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="question-text">Is it a crime? Please check video and answer carefully.</div> -->

    <div
    v-bind:class="{
      disabled: verificationIsCompleted || verificationResult
    }"
    class="action-btns">

      <div class="width-100 row">
        <div
        v-on:click="openCallPoliceModal" ontouchstart=""
        class="action-btn red">
          <div class="btn-text">DISPATCH</div>
        </div>
        <div
        v-on:click="openDisregardModal" ontouchstart=""
        class="action-btn gray">
          <div class="btn-text">Disregard</div>
        </div>
      </div>
      
      <div
      v-bind:class="{
        red: verificationResult === 'dispatch',
        blue: verificationResult === 'cancel',
        black: verificationIsCompleted && !verificationResult
      }"
      class="disabled-text">Alarm verification is finished.</div>
      
      <!-- <div
      v-on:click="openDisregardModal" ontouchstart=""
      class="action-btn">
        <div class="btn-text">+ 1 Mins</div>
      </div> -->

      

    </div>
    <!-- <div style="min-height:2em;"
    v-bind:class="{
      disabled: verificationIsCompleted || verificationResult
    }"
    class="action-btns">
      <div style="font-size: 0.8rem;min-height:2em;width:100%;"
      v-on:click="_addTimeCount" ontouchstart=""
      class="action-btn grayblue" v-bind:class="{disabled : isAddTime}">
        <div class="btn-text">+ Add Time 5 Minutes</div>
      </div> 
    </div> -->


    <div class="answer-container" >
      <comp-verification-logs ref="verificationLog"></comp-verification-logs>
    </div>

    <!-- MODAL: Call Police -->
    <comp-modal-confirm
    v-if="modals.callPolice.isVisible"
    v-on:onClose="modals.callPolice.onCloseAction"
    v-bind:cancelString="modals.callPolice.cancelString"
    v-bind:confirmString="modals.callPolice.confirmString"
    v-bind:confirmDescription="modals.callPolice.confirmDescription"
    v-bind:isDangerous="modals.callPolice.isDangerous"></comp-modal-confirm>

    <!-- MODAL: Disregard -->
    <comp-modal-confirm
    v-if="modals.disregard.isVisible"
    v-on:onClose="modals.disregard.onCloseAction"
    v-bind:cancelString="modals.disregard.cancelString"
    v-bind:confirmString="modals.disregard.confirmString"
    v-bind:confirmDescription="modals.disregard.confirmDescription"
    v-bind:isDangerous="modals.disregard.isDangerous"></comp-modal-confirm>

    <!-- MODAL: Disable Privacy -->
    <comp-modal-confirm
    v-if="modals.disablePrivacy.isVisible"
    v-on:onClose="modals.disablePrivacy.onCloseAction"
    v-bind:cancelString="modals.disablePrivacy.cancelString"
    v-bind:confirmString="modals.disablePrivacy.confirmString"
    v-bind:confirmDescription="modals.disablePrivacy.confirmDescription"
    v-bind:isDangerous="modals.disablePrivacy.isDangerous"></comp-modal-confirm>

  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
import CompModalConfirm from '@/components/CompModalConfirm'
import CompVerificationEventMedia from '@/components/CompVerificationEventMedia'
import CompVerificationLiveSnapshot from '@/components/CompVerificationLiveSnapshot'
import CompVerificationLogs from '@/components/CompVerificationLogs'
export default {
  name: 'verification-page',
  components: {
    CompIcon,
    CompModalConfirm,
    CompVerificationEventMedia,
    CompVerificationLiveSnapshot,
    CompVerificationLogs
  },
  computed: {
    verificationInfo: function () {
      return this.$store.getters.verificationInfo
    },
    verificationEvent: function () {
      return this.$store.getters.verificationEvent
    },
    verificationRequesteeSite: function () {
      return this.$store.getters.verificationRequesteeSite
    },
    getVerificationErrorCode: function () {
      return this.$store.getters.getVerificationErrorCode
    },
    isGetVerificationSuccess: function () {
      return this.$store.getters.isGetVerificationSuccess
    },
    hasDevicesInPrivacyMode: function () {
      return this.$store.getters.verificationSitePrivacyDeviceList.length > 0
    },
    verificationIsCompleted: function () {
      return this.$store.getters.verificationIsCompleted
    },
    verificationResult: function () {
      return this.$store.getters.verificationResult
    },
    remainVerificationTime: function () {
      return this.$store.getters.remainVerificationTime
    },
    idToken: function () {
      return this.$store.getters.idToken
    }
  },
  data: function () {
    return {
      // bus: new Vue(),
      isAddTime: false,
      tokenInfo: {
        deviceName: null,
        alarmZone: null,
        alarmZones: []
      },
      verificationLocaleString: null,
      friendlyVerificationTimeString: null,
      friendlyEventTimeString: null,
      modals: {
        callPolice: {
          isVisible: false,
          onCloseAction: this.onCloseCallPoliceModal,
          confirmString: 'Dispatch',
          cancelString: 'Close',
          isDangerous: true,
          confirmDescription: 'Do you want us to<br>dispatch?'
        },
        disregard: {
          isVisible: false,
          onCloseAction: this.onCloseDisregardModal,
          confirmString: 'Disregard',
          cancelString: 'Close',
          isDangerous: false,
          confirmDescription: 'Do you want us to<br>disregard the alarm?'
        },
        disablePrivacy: {
          isVisible: false,
          onCloseAction: this.onCloseDisablePrivacyModal,
          confirmString: 'Allow',
          cancelString: '<span style="font-size: 0.8em">Do Not Allow</span>',
          isDangerous: true,
          confirmDescription: '<span style="font-size:1em;">Do you want to allow the monitoring station access to cameras in privacy mode on your site for the next hour?  This will assist them in providing detail information about this alarm event.</span>'
        }
      },
      curTab: 'event'
    }
  },
  watch: {
    getVerificationErrorCode: function () {
      this.checkGetVerificationErrorCode()
    },
    verificationInfo: function () {
      if (this.verificationInfo) {
        this.updateVerificationInfo()
      }
    }
  },
  mounted: function () {
    window.addEventListener(
      'orientationchange',
      this.handleOrientationChange
    )
  },
  created: function () {
    this.checkGetVerificationErrorCode()
    this.updateInfoDataFromIdToken()
  },
  methods: {
    updateVerificationInfo: function () {
      if (this.verificationInfo && this.verificationEvent) {
        let timezoneOffset = this.$tool.getUtcOffset(this.verificationRequesteeSite.timezone)
        let verificationLocalTimestamp = this.$tool.getLocalTimestamp(+this.verificationEvent.eventTimestamp * 1000, timezoneOffset)
        this.verificationLocaleString = this.$tool.setFormatLocalTimeFromTimstamp(verificationLocalTimestamp)
        this.friendlyVerificationTimeString = this.$tool.getTimeDiffFromNow(+this.verificationEvent.eventTimestamp * 1000).textDetail + ' ago'
      }
    },
    openCallPoliceModal: function () {
      this.modals.callPolice.isVisible = true
    },
    closeCallPoliceModal: function () {
      this.modals.callPolice.isVisible = false
    },
    openDisregardModal: function () {
      this.modals.disregard.isVisible = true
    },
    closeDisregardModal: function () {
      this.modals.disregard.isVisible = false
    },
    openDisablePrivacyModal: function () {
      this.modals.disablePrivacy.isVisible = true
    },
    closeDisablePrivacyModal: function () {
      this.modals.disablePrivacy.isVisible = false
    },
    onCloseCallPoliceModal: function ({isToProceed}) {
      this.closeCallPoliceModal()
      if (isToProceed) {
        this.createVerificationResponse(true).then(
          success => {
            if (this.hasDevicesInPrivacyMode) {
              this.openDisablePrivacyModal()
            }
          },
          err => {
            console.log(err)
          }
        )
      }
    },
    onCloseDisregardModal: function ({isToProceed}) {
      this.closeDisregardModal()
      if (isToProceed) {
        this.createVerificationResponse(false)
      }
    },
    onCloseDisablePrivacyModal: function ({isToProceed}) {
      this.closeDisablePrivacyModal()
      if (isToProceed) {
        let durationSec = 60 * 60 * 1 // 1 hour
        this.setVerificationPrivacyDisabledDuration(durationSec)
      }
    },
    createVerificationResponse: function (isCrime) {
      return this.$store.dispatch('createVerificationResponse', {
        isCrime: isCrime
      })
    },
    setVerificationPrivacyDisabledDuration: function (durationSec) {
      this.$store.dispatch('setVerificationPrivacyDisabledDuration', {
        durationSec: durationSec
      })
    },
    onClickEventVideo: function () {
      let snapshotContainer = this.$refs['snapshot-container']
      let element = this.$refs['event-snapshot']
      let notiBar = this.$refs['noti-bar']
      this.curTab = 'event'
      if (this.$isMobile()) {
        if (snapshotContainer) {
          snapshotContainer.scrollLeft = 0
        }
        if (notiBar && (!this.verificationIsCompleted && !this.verificationResult)) {
          setTimeout(() => {
            notiBar.scrollIntoView()
          }, 50)
        }
      } else {
        if (element) {
          element.scrollIntoView({behavior: 'smooth'})
        }
        if (notiBar && (!this.verificationIsCompleted && !this.verificationResult)) {
          setTimeout(() => {
            notiBar.scrollIntoView({behavior: 'smooth'})
          }, 1200)
        }
      }
    },
    onClickLiveVideo: function () {
      let snapshotContainer = this.$refs['snapshot-container']
      let element = this.$refs['live-snapshot']
      let notiBar = this.$refs['noti-bar']
      this.curTab = 'live'
      if (this.$isMobile()) {
        if (snapshotContainer) {
          snapshotContainer.scrollLeft = element.scrollWidth
        }
        if (notiBar && (!this.verificationIsCompleted && !this.verificationResult)) {
          setTimeout(() => {
            notiBar.scrollIntoView()
          }, 50)
        }
      } else {
        if (element) {
          element.scrollIntoView({behavior: 'smooth'})
        }
        if (notiBar && (!this.verificationIsCompleted && !this.verificationResult)) {
          setTimeout(() => {
            notiBar.scrollIntoView({behavior: 'smooth'})
          }, 1200)
        }
      }
    },
    checkGetVerificationErrorCode: function () {
      if (this.getVerificationErrorCode) {
        this.goToTokenInvalidPage()
      }
    },
    goToTokenInvalidPage: function () {
      this.$router.push({name: 'TokenInvalid', query: this.$route.query})
    },
    _addTimeCount: function () {
      this.isAddTime = true
      this.$refs.verificationLog.addTimeCount(300)
      this.$forceUpdate()
      // console.log(this.isAddTime)
    },
    eventErr: function () {
      this.onClickLiveVideo()
    },
    snapshotViewScroll: function (e) {
      const scrollLeft = e['target']['scrollLeft']
      const clientWidth = e['target']['clientWidth']
      const scrollWidth = e['target']['scrollWidth']

      if (scrollLeft + clientWidth >= scrollWidth) {
        this.curTab = 'live'
      } else if (scrollLeft === 0) {
        this.curTab = 'event'
      }
    },
    updateInfoDataFromIdToken: function () {
      if (this.idToken) {
        let object = this.$tool.decodeJwtToken(this.idToken)
        console.log(object)
        if ('alarm_zone' in object) {
          this.tokenInfo.alarmZone = object['alarm_zone']
          this.tokenInfo.alarmZones = object['alarm_zone'].split(',')
        }
        if ('device_name' in object) {
          this.tokenInfo.deviceName = object['device_name']
        }
      }
      console.log(this.tokenInfo)
    },
    handleOrientationChange: function () {
      const orientation = window.screen.orientation.type
      const snapshotContainer = this.$refs['snapshot-container']
      if (this.curTab === 'event') {
        snapshotContainer.scrollLeft = 0
      } else if (this.curTab === 'live') {
        setTimeout(() => {
          snapshotContainer.scrollLeft = snapshotContainer.scrollWidth
        }, 100)
      }

      if (orientation === 'portrait-primary') {
        // portrait mode
      } else if (orientation === 'landscape-primary') {
        // landscape mode
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.verification-page {
  /* common */
  background-color: #000;
  color: #fff;
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
  /* alignment */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  /* style */
  box-shadow: 0 0 4px 0 hsla(0, 0%, 0%, 0.5);
}

.verification-page .header {
  /* common */
  background-color: #212121;
  font-size: 0.7em;
  /* size */
  width: calc(100% - 2em);
  padding: 1em;
  /* text */
  text-transform: uppercase;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.verification-page .snapshot-list {
  /* size */
  // max-width: 600px;
  width: 100%;
}

.verification-page .tab-btns {
  /* size */
  width: 128px;
  height: 28px;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #000000;
  border-radius: 5px;
  font-size: 14px;
  padding: 2px;
  box-sizing: border-box;
  /* color */
  background: #2b2b2b;
  .tab-btn {
    /* common */
    // background-color: #fff;
    color: hsla(0, 0%, 100%, 0.6);
    font-size: 0.8em;
    border-radius: 5px;
    padding: 4px 14px;
    /* mouse */
    cursor: pointer;
    /* text */
    font-weight: bold;
    text-transform: uppercase;
    /* size */
    width: 50%;
    height: 100%;
    /* alignment */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    &.sel-tab {
      background-color: #434343;
      color: hsla(0, 0%, 100%, 0.87);
    }
    &:hover {
      /* common */
      background-color: hsl(0, 0%, 30%);
    }
  }
}

.verification-page .snapshot-list .snapshot-containers-wrapper {
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}

.verification-page .snapshot-list .snapshot-container {
  /* common */
  background-color: transparent;
  /* size */
  min-width: 100%;
}

.verification-page .action-btns {
  /* common */
  border-top:hsla(0, 100%, 100%, 0.1);
  // background-color: #000;
  font-size: 1em;
  /* size */
  width: 100%;
  // max-width: 600px;
  min-height: 4em;
  // min-height: 4em;
  /* position */
  position: relative;
  /* alignment */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-top: 1px solid hsla(0, 100%, 100%, 0.1);
  padding: 0.5em 1em;
  .width-100 {
    width: 100%;
  }
}
.verification-page .action-btns .disabled-text{
  /* common */
  background-color: hsla(202, 100%, 50%, 1);
  color: #fff;
  opacity: 0;
  z-index: -1;
  /* text */
  font-weight: bold;
  /* position */
  position: absolute;
  top: 0em;
  left: 1em;
  /* size */
  border: 2px solid #fff;
  // margin: 0px 4px;
  width: calc(100% - 2em);
  min-height: calc(100%);
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  /* animation */
  transition: opacity .3s;
}
.verification-page .action-btns .disabled-text.red{
  background-color: #CD3D64;
  color: #fff;
}
.verification-page .action-btns .disabled-text.blue{
  background-color: hsla(202, 100%, 50%, 1);
  color: #fff;
}
.verification-page .action-btns .disabled-text.black{
  background-color: hsla(202, 100%, 0%, 1);
  color: #fff;
}
.verification-page .action-btns.disabled {
  /* mouse */
  pointer-events: none;
}
.verification-page .action-btns.disabled .disabled-text{
  /* common */
  opacity: 1;
  z-index: 1;
}
.verification-page .action-btns .action-btn {
  /* common */
  font-size: 1em;
  background-color: hsla(0, 0%, 100%, 1);
  color: hsla(0, 0%, 0%, 1);
  /* mouse */
  cursor: pointer;
  /* size */
  padding: 0 1em;
  width: 100%;
  min-height: 45px;
  border-right: 1px solid #000;
  border-radius: 5px;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  &:not(:first-child) {
    margin-left: 10px;
  }
}
.verification-page .action-btns .action-btn:last-child {
  /* size */
  border-right-width: 0px;
}
.verification-page .action-btns .action-btn.red {
  /* common */
  background-color:#CD3D64;
  color: #fff;
  &:hover {
    background-color: #D25074;
  }
  &:active {
    background-color: #B43658;
  }
}
.verification-page .action-btns .action-btn.gray{
  background-color: #6D6D6D;
  color: #fff;
  &:hover {
    background-color: #7c7c7c;
  }
  &:active {
    background-color: #606060;
  }
}
.verification-page .action-btns .action-btn.grayblue{
  min-height: 2em;
  background-color: hsla(208, 42%, 40%, 0.92);
  color: #fff;
  &.disabled {
    pointer-events: none;
    background-color: hsla(208, 1%, 24%, 0.92);
  }
  &:hover {
    background-color: hsla(208, 42%, 50%, 0.92);
  }
}
.verification-page .action-btns .action-btn .btn-text {
  /* common */
  font-size: 16px;
  /* text */
  font-weight: bold;
  text-transform: uppercase;
}


.verification-page .answer-container {
  /* common */
  display: flex;
  overflow: hidden;
  // overflow-y: auto;
  // overflow-y: overlay;
  // overflow-y: overlay;
  align-items: flex-start;
  // background-color: #000;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  /* size */
  width: calc(100% - 6px);
  // max-width: 600px;
  min-height: 200px;
  max-height: 55vh;
  height: 100%;
  padding: 1em 0em 0em 0em;
  box-sizing: border-box;
  // margin: 3px;
  /* position */
  position: relative;
  flex: 1;
}

.verification-page {
  max-width: 600px;
  .row {
    display: flex;
  }
  .between {
    justify-content: space-between;
  }
  .noti-bar {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    // max-width: 600px;
    height: 0px;

    text-align: center;
    overflow: hidden;
    transition: all .2s;
    font-size:12px;
    color: #fff;
    background: #1e88e5;
    &.noti-bar-visible {
      height: 20px;
      min-height: 20px;
      padding: 0.5em 0;
      animation-duration: 1s;
      animation-name: expend;
    }
  }
  .info-menu {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // max-width: 600px;
    width: 100%;
    min-height: 5em;
    padding: 1em;
    box-sizing: border-box;
    .mb-5 {
      margin-bottom: 0.4em;
    }
    .time-label {
      display: flex;
      align-items: center;
      font-size: 17px;
      color: #fff;
      line-height: 26px;
      .event-time {
        margin-right: 0.3em;
      }
      .friendly-time {
        color: hsla(0, 0%, 100%, 0.6);
        font-size: 0.75em;
      }
      .live-txt {
        margin-left: 0.2em;
      }
    }
    .device-name {
      /* alignment */
      display: flex;
      align-items: center;
      /* font */
      font-size: 16px;
      color: hsla(0, 100%, 100%, 0.6);
    }
    .zone-number {
      display: flex;
      align-items: center;
      margin-left: 0.4em;
      padding: 0em 0.4em;
      font-size: 12px;
      color: hsla(0, 100%, 100%, 0.6);
      background-color: #383838;
      border-radius: 3px;
      border: 1px solid rgba(255, 255, 255, 0.05);
      .zone-number-txt {
        // padding: 2px;
      }
    }
  }
  
}

.dot-holder {
  width: 20px;
  height: 20px;
  position: relative;
  .pulse {
    width: 5px;
    height: 5px;
    border: 3px solid #1e88e5;
    background-color: #1e88e5;
    border-radius: 15px;
    z-index: 10;
    position: absolute;
    left: 7px;
    top: 7px;
  }
  .dot {
    border: 10px solid #1e88e5;
    background: transparent;
    border-radius: 30px;
    height: 15px;
    width: 15px;
    -webkit-animation: pulse 3s ease-out;
    animation: pulse 3s ease-out;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1;
    opacity: 0;
  }
}


@keyframes pulse {
  0% {
    -webkit-transform: scale(0);
    opacity: 0.0;
  }
  25% {
    -webkit-transform: scale(0);
    opacity: 0.1;
  }
  50% {
    -webkit-transform: scale(0.1);
    opacity: 0.3;
  }
  75% {
    -webkit-transform: scale(0.5);
    opacity: 0.5;
  }
  100% {
    -webkit-transform: scale(1);
    opacity: 0.0;
  }
}

.align-center {
  align-items: center;
}

@keyframes expend {
  from {
    height: 0px;
  }

  to {
    height: 20px;
  }
}

@media (orientation: landscape) {
  .verification-page {
    overflow: overlay;
    .answer-container {
      overflow: visible;
      min-height: fit-content;
      max-height: 100%;
    }
  }
}

@media screen and (max-width: 1280px) {
  .verification-page {
    max-width: 750px;
  }
  .verification-page .action-btns {
    max-width: 750px;
  }
  .verification-page .answer-container { 
    max-width: 750px;
  }
}

@media screen and (min-width: 1280px) {
  .verification-page .action-btns {
    max-width: 600px;
  }
  .verification-page .answer-container { 
    max-width: 600px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Verification/VerificationPage.vue